<template>
  <div class="case">
    <banner class='case-top' img="../assets/img/bgtop.jpg" title="业绩案例" />
    <div class="case-section" v-loading="loading" style="    ">
      <div class="case-section-content">
        <div class="listbtn">
          <div class="w_1300">
              <div class="wrapper wrapper03" id="wrapper03">
                  <div class="scroller" style="width: 100%;">
                      <div class="one_ul">
                        <ul class="clearfix" style="justify-content: center;">
                          <li  v-for="(tab, index) in tabs"  
                            :key="index"  
                            :class="{ active: currentIndex === index }"  
                            @click="setCurrentIndex(index)"  
                          >
                            <a class="wave-effect" href="#" > {{ tab.title }}  </a>
                          </li>
                        </ul>
                      </div>
                      <div v-for="(tab, index) in tabs" :key="index" v-show="currentIndex === index">  
                        
                        <ul class="case-item" style="justify-content: center;">
                          <li
                            v-for="(item,index) in pagedData"
                            :key="index"
                          >
                            <div class ='case-li-div-one' v-lazy:background-image="imgserver + item.img" ></div>
                            <div class ='case-li-div-two'>
                              <h3><span>{{item.Title}}</span></h3>
                              <p>
                                <span>查看详情</span>
                                <small>
                                    <img src="../assets/img/j_hui.png" class="hui">
                                    <img src="../assets/img/j_hong.png" class="hong">
                                </small>
                               </p>
                            </div>
                            <router-link
                              class="text-decoration"
                              :to="{ name: 'casedetails', params: { id: item.id }}"
                            >
                              <div class="case-item-hover">
                                <p class="hover-title">{{item.title}}</p>
                                <div class="bottom"></div>
                                <div class="more">
                                  <span>点击查看</span>
                                </div>
                              </div>
                            </router-link>
                            
                          </li>
                        </ul>
                        <div class="page-div">
                          <button @click="currentPage--" :disabled="currentPage <= 1">上一页</button>
                          <span>第 {{ currentPage }} 页</span>
                          <button @click="currentPage++" :disabled="currentPage >= totalPages">下一页</button>
                        </div>
                      </div>  
                  </div>
              </div>

           
          </div>
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>
<script>
import Banner from "../components/Banner";
import Bottom from "../components/Bottom"; 

export default {
  components: {
    Banner,
    Bottom
  },
  data() {
    return {
      loading: true,
      caseList: [],
      currentIndex: 0, // 当前选中的选项卡索引  
      //分页
      currentPage: 1,
      pageSize: 12,
      //项目分类选项卡
      tabs: [  
        { title: '工程监理', content: '这是Tab 1的内容。' },  
        { title: '项目咨询', content: '这是Tab 2的内容，更多一些内容来显示。' },  
        { title: 'BIM咨询服务', content: 'Tab 3的内容。' }  ,
        { title: '工程管理软件开发', content: 'Tab 4的内容。' } ,
        { title: '存量资产盘整尽职调查', content: 'Tab 4的内容。' }  
      ],
      //项目默认选项卡
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.caseList.length / this.pageSize);
    },
    pagedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.caseList.slice(start, end);
    }
  },
  mounted() {
    window.console.log("case");
    this.$http
      .get("/gw/Cases/get_cases_all?type=1")
      .then(response => {
        //console.log(response);
        this.caseList = response.data;
        //window.console.log(this.caseList);
        this.loading = false;
      })
      .catch(function(error) {
        window.console.log(error);
      });
  },
  methods: {  
    setCurrentIndex(index) {  
      this.currentIndex = index; 
      this.currentPage = 1 
      console.log(index);
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.$http
      .get(`/gw/Cases/get_cases_all/?type=` + (parseInt(this.currentIndex) + parseInt(1)))
      .then(response => {
        //console.log(response);
        this.caseList = response.data;
        this.loading = false;
        //window.console.log(this.newsList);
      })
      .catch(function(error) {
        window.console.log(error);
      });
    }
  }  
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
    //  width: 1240px;
      min-height: 1250px;
      margin: 0 auto;
      background-color: #fff;
    }
  }
  .page-div{
    text-align: center;
     font-size: 18px;
     color: #666;
    button{
      font-size: 18px;
      padding: 10px 30px;
      margin: 0 20px;
      border: 1px #bfbfbf solid;
      border-radius: 0;
      margin: 0 5px;
      text-transform: uppercase;
      display: inline-block;
      padding: 5px 14px;
      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 5px;
    }
  }
}

.listbtn {
      width: 100%;
      padding: 30px 0;
    }
    dl, ol, ul {
      list-style: none;
    }
    .wrapper03 .scroller {
      position: absolute;
    }
    .wrapper03 {
      position: relative;
      height: 45px;
      width: 100%;
      margin: 0 auto;
      /* border-bottom: 1px solid #ccc; */
    }
    .w_1300 {
      max-width: 1300px;
      width: 100%;
      margin: 0 auto;
     }
  .one_ul{
      li {
     // height: 45px;
      color: #333;
      float: left;
      line-height: 45px;
      font-size: 25px;
      text-align: center;
    }
    .active {
      border: 2px solid red;
      border-radius: 5px;
      background: #e3e4eb;;
    }
     a {
      color: #333;
      display: block;
      margin: 0 0;
      /* padding: 0 14px; */
      position: relative;
      margin:0px 30px;
      text-decoration: none;
    }
 

    ul li {  
    position: relative;  
    display: inline-block;  
    padding: 10px;  
    margin: 5px;  
    cursor: pointer;  
  }  
  
    ul li a.wave-effect::after {  
      content: '';  
      position: absolute;  
      left: 0;  
      bottom: 0;  
      width: 100%;  
      height: 2px;  
      background: repeating-linear-gradient(-60deg, #6c5ce7, #6c5ce7 10px, #a29bfe 10px, #a29bfe 20px);  
      opacity: 0;  
      transform: scaleX(0);  
      transition: transform 0.5s ease, opacity 0.5s ease;  
    }  
    
   ul li a.wave-effect:hover::after {  
      opacity: 1;  
      transform: scaleX(1);  
    }  
  }

  //经典案例
.case-item {
  width: 100%;
  //height:100%;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .case-li-div-one{
    height: 70%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
  }
  .case-li-div-two{
    background: #fafafa;
    padding: 15px 10px;
  }
  .case-li-div-two h3{
    margin-bottom: 10px;
    font-weight: normal;
  }
  
  .case-li-div-two h3 span {
    font-size: 16px;
    color: #292929;
    font-weight: bold;
  }
  .case-li-div-two p {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .case-li-div-two p span {
    font-size: 14px;
    color: #979797;
  } 
  .case-li-div-two p small {
    width: 25px;
    font-size: 80%;
  }
  .case-li-div-two p small img {
    width: 100%;
    display: block;
    vertical-align: middle;
    border-style: none;
    max-width: 100%;
  }
  .case-li-div-two p small img.hong {
    display: none;
  }

  li {
    width:23% ;
    height: 300px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 1%;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
    text-align: center;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    span {
      color: #fff;
      font-size: 20px;
    }
  }
}
@media screen and (max-width: 700px) { /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
  .one_ul ul{
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
  }
  .one_ul ul li {
    width: 87%;
    font-size: 20px;
  }
  .case-section {
    margin-bottom: 100px;
  }
}
</style>